export enum UserTicketStatus {
    New = 'New',
    Processed = 'Processed',
    Duplicate = 'Duplicate',
    Updated = 'Updated',
    Read = 'Read',
}
